import React, { useState } from 'react';

const defaultValue = {
  conciliacoes: [],
  extratoSelecionado: {},
  contaBancaria: undefined,
  acrescimoDesconto: {},
  credito: 0,
  debito: 0,
  saldoFinal: 0,
  conciliacoesPendentes: 0,
  contaPagar: {},
  filtro: { tipo: 'TODOS', situacao: 'NAO_CONCILIADO' },
  regraAutomatica: {},
  contaReceber: {},
  conciliacao: {},
  transferencia: {},
  arquivo: {},
  leituraArquivo: false,
  formularioLancamentoDespesa: {},
  formularioLancamentoReceita: {},
  formularioTransferencia: {},
  selecao: [],
  tipoSelecao: 'NENHUM',
  loading: false,
  totalElements: 0,
  modal: '',
  search: '',
  page: 0,
  size: 15,
  sort: '',
  searchConciliacoes: {
    page: 0,
    size: 10,
    sort: 'dataHoraLancamento,DESC',
    totalElements: 0,
  },
};

export const ConciliacaoContext = React.createContext({});

export const ConciliacaoProvider = (props) => {
  return (
    <ConciliacaoContext.Provider
      value={{
        conciliacoes: useState(defaultValue.conciliacoes),
        credito: useState(defaultValue.credito),
        debito: useState(defaultValue.debito),
        contaBancaria: useState(defaultValue.contaBancaria),
        extratoSelecionado: useState(defaultValue.extratoSelecionado),
        acrescimoDesconto: useState(defaultValue.acrescimoDesconto),
        saldoFinal: useState(defaultValue.saldoFinal),
        conciliacoesPendentes: useState(defaultValue.conciliacoesPendentes),
        filtro: useState(defaultValue.filtro),
        contaPagar: useState(defaultValue.contaPagar),
        contaReceber: useState(defaultValue.contaReceber),
        transferencia: useState(defaultValue.transferencia),
        conciliacao: useState(defaultValue.conciliacao),
        regraAutomatica: useState(defaultValue.regraAutomatica),
        arquivo: useState(defaultValue.arquivo),
        leituraArquivo: useState(defaultValue.leituraArquivo),
        formularioLancamentoDespesa: useState(defaultValue.formularioLancamentoDespesa),
        formularioLancamentoReceita: useState(defaultValue.formularioLancamentoReceita),
        formularioTransferencia: useState(defaultValue.formularioTransferencia),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        modal: useState(defaultValue.modal),
        search: useState(defaultValue.search),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
        searchConciliacoes: useState(defaultValue.searchConciliacoes),
      }}
    >
      {props.children}
    </ConciliacaoContext.Provider>
  );
};

export const ConciliacaoConsumer = ConciliacaoContext.Consumer;
